"use client";

import dynamic from "next/dynamic";

const PostHogPageView = dynamic(() => import("./PostHogPageView"), {
  ssr: false,
});

export default function PostHogPageViewLazy() {
  return <PostHogPageView />;
}
